export default __webpack_public_path__ + "static/ichi_logo_horizontal_dark-37d0baabefaa018cda5f102b7d591e7e.svg";